var map = {
	"./google-laurel-da-DK.svg": 53450,
	"./google-laurel-de-DE.svg": 65400,
	"./google-laurel-en-GB.svg": 7338,
	"./google-laurel-en-US.svg": 31793,
	"./google-laurel-es-ES.svg": 50514,
	"./google-laurel-es-MX.svg": 21937,
	"./google-laurel-fr-FR.svg": 57522,
	"./google-laurel-it-IT.svg": 92112,
	"./google-laurel-nb-NO.svg": 86847,
	"./google-laurel-nl-NL.svg": 16110,
	"./google-laurel-pl-PL.svg": 35846,
	"./google-laurel-pt-BR.svg": 18218,
	"./google-laurel-pt-PT.svg": 38950,
	"./google-laurel-sv-SE.svg": 57315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;